import { z } from 'zod';
export const FieldAttachedPluginHandlerResponse = z.object({
    formFieldElement: z.object({}).nullable(),
    gridFieldElement: z.object({}).nullable(),
    projectFiles: z.record(z.string()),
});
//# sourceMappingURL=plugin-field-attached-type.js.map